import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import "./caption.scss";

/**
 * Caption is a simple component that can be used to style smaller titles.
 */
export const Caption = ({ align, color, fontsize, ...props }) => {
    const className = classNames({
        Caption: true,
        [`Caption--${align}`]: align,
        [`Caption--${color}`]: color && color.charAt(0) !== "#",
    });

    const getStyle = () => {
        if (!color && !fontsize) {
            return null;
        }

        return {
            color: color && color.charAt(0) === "#" ? color : null,
            fontSize: fontsize ? `${fontsize / 16}rem` : null,
        };
    };

    return (
        <h4 className={className} style={getStyle()} {...props}>
            {props.children}
        </h4>
    );
};

Caption.propTypes = {
    /** Child components/content.  */
    children: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.string,
        PropTypes.arrayOf(
            PropTypes.oneOfType([PropTypes.element, PropTypes.string])
        ),
    ]),

    /** The alignment based on the text direction (LTR/RTL), only use left and right when locale is not applicable. */
    align: PropTypes.oneOf(["side", "center", "left", "right"]),

    /** Color. */
    color: PropTypes.string,

    /** Font size in pixels. */
    fontsize: PropTypes.number,
};

Caption.defaultProps = {
    align: "side",
    color: null,
    fontsize: null,
};
